import React from 'react';
type ArtifactViewMainContentFixInfoHowToFixPackageManageGoVendorProps = {
  component: object;
  safeCommitHash?: string;
  safeVersion?: string;
};
const ArtifactViewMainContentFixInfoHowToFixPackageManageGoVendor: React.SFC<
  ArtifactViewMainContentFixInfoHowToFixPackageManageGoVendorProps
> = props => {
  const { component, safeCommitHash, safeVersion } = props;
  const commitOrVersionText = safeCommitHash ? 'commit' : 'version';
  return (
    <div className="pt-">
      <div className="grid pt">
        <span className="grid__item pv- p0">
          Execute the following to install the fix {commitOrVersionText}
        </span>
      </div>
      <div className="pt-- -ml mt-">
        <span className="font-family--code bg-color--white-medium p- inline-block">{`govendor fetch ${
          component.name
        }@${safeCommitHash || safeVersion}`}</span>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentFixInfoHowToFixPackageManageGoVendor;
